import { green, red, yellow, blue } from "@ant-design/colors";

import { COLUMN_KEYS, COLUMN_LABELS } from "constants/table";

export const DETECTED_CODE_TYPE_CLASS_MAP = {
  GOOD: "green",
  DEFECT: "red",
  ERROR: "yellow",
  NOT_APPLICABLE: "blue",
};

export const DETECTED_CODE_TYPE_COLOR_MAP = {
  GOOD: green.primary,
  DEFECT: red.primary,
  ERROR: yellow.primary,
  NOT_APPLICABLE: blue.primary,
};

export const FIELD_KEYS = {
  ...COLUMN_KEYS,
  DETECTED_CODE: "detected_code",
  STATUS: "status",
  X: "x",
};

export const FIELD_LABELS = {
  ...COLUMN_LABELS,
  [FIELD_KEYS.DETECTED_CODE]: "Detected Code",
  [FIELD_KEYS.STATUS]: "Status",
  [FIELD_KEYS.X]: "x",
};

export const FIELD_ORDERS = [
  COLUMN_KEYS.NO,
  FIELD_KEYS.X,
  FIELD_KEYS.STATUS,
  FIELD_KEYS.DETECTED_CODE,
  FIELD_KEYS.ACTION,
];

export const TABLE_FIELDS = [
  FIELD_KEYS.ACTION,
  FIELD_KEYS.DETECTED_CODE,
  COLUMN_KEYS.NO,
  FIELD_KEYS.STATUS,
  FIELD_KEYS.X,
];

export const TABLE_SORTABLE_FIELDS = [
  FIELD_KEYS.DETECTED_CODE,
  FIELD_KEYS.STATUS,
  FIELD_KEYS.X,
];

export const DETAIL_FIELDS = [
  FIELD_KEYS.DETECTED_CODE,
  FIELD_KEYS.STATUS,
  FIELD_KEYS.X,
];
